import { useEffect, useState } from "react";

import { Card } from "../../../components/Card";

import { api } from "../../../services/api";
import { AxiosError } from "axios";
import { AddButton } from "../../../components/atoms/Button/AddButton";
import { ButtonListButton } from "../../../components/organisms/ButtonListBox";
import { useNavigate } from "react-router-dom";
import { EditButton } from "../../../components/molecules/EditButton";
import { DeleteModal } from "../../../components/templates/DeleteModal";
import { useAuth } from "../../../hooks/auth";
import { useQuery } from "../../../hooks/query";
import { Table } from "../../../components/templates/Table";
import { checkPermission } from "../../../utils/checkPermission";

interface AccountPlanSubcategory {
  id: string;
  name: string;
  type: string;
  account_plan_category: {
    name: string;
  };
}
interface Params {
  page: number;
  limit_per_page: number;
  search: string;
  order_column?: string;
  order_type?: string;
}
export function ListAccountPlanSubcategories() {
  const query = useQuery();

  const { user } = useAuth();
  const navigate = useNavigate();
  const [accountPlanSubcategories, setAccountPlanSubcategories] = useState<
    AccountPlanSubcategory[]
  >([]);
  const [loading, setLoading] = useState(false);

  const [total, setTotal] = useState<number>(0);
  const [defaultParams, setDefaultParams] = useState<Params>({
    limit_per_page: query.get("limit") ? Number(query.get("limit")) : 10,
    page: query.get("offset") ? Number(query.get("offset")) : 1,
    search: query.get("search") ?? "",
    order_column: query.get("order_column") ?? "",
    order_type: query.get("order_type") ?? "",
  });
  useEffect(() => {
    api
      .get(
        `accountPlanSubcategories/pagination?offset=${defaultParams.page}&limit=${defaultParams.limit_per_page}&search=${defaultParams.search}&order_column=${defaultParams.order_column}&order_type=${defaultParams.order_type}`
      )
      .then((response) => {
        setAccountPlanSubcategories(response.data.accountPlanSubcategories);
        setTotal(response.data.total);
        setLoading(true);
      })
      .catch((err: AxiosError) => {
        navigate(`/error/${err.response?.status}`);
      });
  }, [navigate, user.company_id, defaultParams]);
  return (
    <>
      <Card
        border="#216ca5"
        title="Receitas/Despesas"
        header={<AddButton link="/receita/despesa/cadastrar" />}
        body={
          <Table
            loading={loading}
            message="Buscando as contas"
            params={defaultParams}
            setDefaultParams={(params) => {
              setDefaultParams(params);
              navigate(
                `/receitas/despesas?offset=${params.page}&limit=${params.limit_per_page}&search=${params.search}&order_column=${params.order_column}&order_type=${params.order_type}`
              );
            }}
            total={total}
            data={accountPlanSubcategories.map((accountPlanSubcategory) => {
              return {
                tr: [
                  {
                    name: accountPlanSubcategory.name,
                  },
                  {
                    name: accountPlanSubcategory.account_plan_category.name,
                  },
                  {
                    name: (
                      <ButtonListButton>
                        <EditButton
                          link={`/receita/despesa/${accountPlanSubcategory.id}`}
                        />
                        {checkPermission({
                          is_admin: user.is_admin,
                          type: "Super Admin",
                        }) ? (
                          <DeleteModal
                            onDelete={(id) => {
                              setAccountPlanSubcategories(
                                accountPlanSubcategories.filter(
                                  (accountPlanSubcategory) =>
                                    accountPlanSubcategory.id !== id
                                )
                              );
                            }}
                            id={accountPlanSubcategory.id}
                            route="accountPlanSubcategories/"
                            error_message="Não foi possível remover a conta"
                            success_message="Conta removida com sucesso"
                          />
                        ) : (
                          <></>
                        )}
                      </ButtonListButton>
                    ),
                  },
                ],
              };
            })}
            columns={[
              {
                name: "name",
                label: "Nome",
                options: {
                  sort: true,
                },
              },
              {
                name: "accountPlanCategory",
                label: "Conta",
                options: {
                  sort: true,
                },
              },
              {
                name: "action",
                label: "Ações",
                options: {
                  sort: false,
                },
              },
            ]}
          />
        }
      />
    </>
  );
}
